import { createReducer } from '@reduxjs/toolkit';

import { MOBILE_SESSION_STOP } from './../../types';
import constants from './constants';
import operations from './operations';
import actions from './actions';
import { UploadToSdFile } from './records';

type UploadToSdCardState = {
  readonly allFiles: UploadToSdFile[];
  readonly files: UploadToSdFile[];
  readonly searchTerm: string;
}

const initialState: UploadToSdCardState = {
  allFiles: [],
  files: [],
  searchTerm: '',
};

const uploadToSdCardReducer = createReducer(initialState, (builder) => {
  // uploadToSdCard
  builder.addCase(operations.uploadToSdCard.pending, (draft, { meta: { arg: fileUpload } }) => {
    draft.allFiles = [fileUpload, ...draft.allFiles];
    draft.files = [...draft.allFiles];
    draft.searchTerm = '';
  });
  builder.addCase(operations.uploadToSdCard.fulfilled, (draft, { meta: { arg: fileUpload } }) => {
    const sanitizedData = draft.allFiles.map((file) => {
      if (file.id === fileUpload.id) {
        file.status = constants.UPLOAD_STATUS.UPLOADED; // eslint-disable-line no-param-reassign
      }
      return file;
    });

    draft.allFiles = [...sanitizedData];
    draft.files = [...sanitizedData];
  });
  builder.addCase(operations.uploadToSdCard.rejected, (draft, { meta: { arg: fileUpload } }) => {
    const sanitizedData = draft.allFiles.map((file) => {
      if (file.id === fileUpload.id) {
        file.status = constants.UPLOAD_STATUS.FAILED; // eslint-disable-line no-param-reassign
      }
      return file;
    });

    draft.allFiles = [...sanitizedData];
    draft.files = [...sanitizedData];
  });

  // search by name
  builder.addCase(actions.searchByFileName, (draft, { payload: searchTerm }) => {
    draft.searchTerm = searchTerm;
    draft.files = draft.allFiles.filter((file) => (
      file.name.toLowerCase().includes(searchTerm.toLowerCase())
    ));
  });

  // stop session
  builder.addCase(MOBILE_SESSION_STOP.REQUEST, () => initialState);
});

export default uploadToSdCardReducer;
export {
  initialState,
  UploadToSdCardState,
};
